module.exports = new __parcel__URL__("seal.de226e3b.svg").toString();